<iframe
  title="kc login iframe"
  id="kc-login-iframe"
  src="assets/keycloak-login-iframe/keycloak-login-iframe.html"
>
</iframe>
